import { StoryblokTableSection } from '@cinch-nx/data-storyblok'
import { CheckTickIcon, CrossIcon } from '@cinch-nx/design-system-icons'
import styles from './seo-table.module.css'

function renderBody(body: string) {
  if (body.includes('*check-tick-icon*')) {
    return (
      <>
        <CheckTickIcon size={24} />
        <div>{body.replace('*check-tick-icon*', '')}</div>
      </>
    )
  } else if (body.includes('*cross-icon*')) {
    return (
      <>
        <CrossIcon size={24} />
        <div>{body.replace('*cross-icon*', '')}</div>
      </>
    )
  } else {
    return body
  }
}
export const SEOTable: React.FC<StoryblokTableSection> = ({
  heading,
  table,
}) => (
  <>
    {heading && <h2 className={styles.heading}>{heading}</h2>}
    <div className={styles.scroll}>
      <table className={styles.table} aria-label={heading}>
        <thead>
          <tr>
            {table.thead.map((heading) => (
              <th key={heading._uid} aria-label={heading.value}>
                {heading.value}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {table.tbody
            .filter((row) => !!row.body[0].value)
            .map((row) => (
              <tr key={row._uid}>
                {row.body.map((cell) => (
                  <td key={cell._uid} aria-label={cell.value.toString()}>
                    {renderBody(cell.value.toString())}
                  </td>
                ))}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  </>
)
